/** @format */

import React, { createContext, useState, useEffect } from 'react'
import { Card, Tabs, Tab, _$ } from 'kpc-react'
import MonitorCrumb from 'src/components/MonitorCrumb'
import Contacts from './Contacts'
import ContactGroup from './ContactGroup'
import { request } from 'src/utils'
import { UserGroupProps } from 'src/containers/MonitorContacts/constants'
import API from 'src/api/ApiContacts'

export const CountContext = createContext<{
  groupList?: UserGroupProps[]
  getUserGroup?: () => void
}>({})

const MonitorContacts: React.FC<any> = () => {
  const [tabValue, setTabValue] = useState<string>('man')
  const [groupList, setGroupList] = useState<UserGroupProps[]>([])

  useEffect(() => {
    getUserGroup()
  }, [tabValue])

  // 获取联系组
  const getUserGroup = async () => {
    const result = await request(API.getUserGroup, {
      data: {
        Cap: 1,
        pageIndex: 1
      }
    })
    const { code, data } = result
    if (code === 'Success') {
      setGroupList(data?.usergrplist || [])
    }
  }

  return (
    <div>
      <CountContext.Provider
        value={{
          groupList,
          getUserGroup
        }}
      >
        <MonitorCrumb breadArr={[{ title: _$('联系人管理') }]} />
        <Card>
          <Tabs value={tabValue} on$change-value={(c, tab) => setTabValue(tab)}>
            <Tab value="man">{_$('联系人')}</Tab>
            <Tab value="group">{_$('联系组')}</Tab>
          </Tabs>
          <div className="marginTop">
            <>
              {tabValue === 'man' && <Contacts />}
              {tabValue === 'group' && <ContactGroup />}
            </>
          </div>
        </Card>
      </CountContext.Provider>
    </div>
  )
}
export default MonitorContacts
